module.exports = __webpack_public_path__ + "assets/img/img3.0caea5a9.png";